import { queryOptions } from '@tanstack/react-query'

import {
  GetCitiesRequest,
  GetCountriesRequest,
  GetProvincesRequest,
} from '@/_gql/graphql'

import { gqlFetch } from '../graphql/fetcher'
import { GqlGeoCities, GqlGeoCountries, GqlGeoProvinces } from './gql'

export function queryGeoCountries(req: GetCountriesRequest) {
  const { name = '' } = req
  return queryOptions({
    queryKey: ['geo', 'countries', name],
    queryFn: async () => {
      const res = await gqlFetch({
        query: GqlGeoCountries,
        variables: { request: { name: name } },
      })
        .then((x) => x.getCountries.data)
        .then((x) => x.map((y) => ({ label: y.name, value: y.id })))

      return res
    },
  })
}

export function queryGeoProvinces(req: GetProvincesRequest) {
  const { country_id, name = '' } = req
  return queryOptions({
    queryKey: ['geo', 'provinces', country_id, name],
    enabled: Boolean(country_id),
    queryFn: async () => {
      const res = await gqlFetch({
        query: GqlGeoProvinces,
        variables: { request: req },
      })

      return res.getProvinces.data.map((x) => ({ label: x.name, value: x.id }))
    },
  })
}

export function queryGeoCities(req: GetCitiesRequest) {
  const { country_id, province_id, name = '' } = req
  return queryOptions({
    queryKey: ['geo', 'cities', country_id, province_id, name],
    enabled: Boolean(country_id) && Boolean(province_id),
    queryFn: async () => {
      const res = await gqlFetch({
        query: GqlGeoCities,
        variables: { request: { country_id, province_id, name } },
      })
      return res.getCities.data.map((x) => ({ label: x.name, value: x.id }))
    },
  })
}

export function queryGeoNationalities(req: GetCountriesRequest) {
  const { name = '' } = req
  return queryOptions({
    queryKey: ['geo', 'nationalities', name],
    queryFn: async () => {
      const res = await gqlFetch({
        query: GqlGeoCountries,
        variables: { request: { name: name } },
      })
        .then((x) => x.getCountries.data)
        .then((x) => x.map((y) => ({ label: y.name, value: y.id })))

      return res
    },
  })
}
